const LugosiEpsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static"> 

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/2Fw2aPrrgKoQ4SwsRMP4GX?si=K6ez-PeGTdGq2xnPBBrz9A" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-cC2aN5eijvyUdGX8-qs9Ftg-t500x500.png" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ninth circle</strong><br/>
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/0p24gzQWRSPU0WzrAvOGew?si=9XTl_90_Rqa1Rs-EBNI91Q" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-26umkN6jwMHd2ZPL-0LuWYA-t500x500.png" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>her lips were poison but so were mine</strong><br/>
                (prod. jolst)
              </p>
            </a>
          </div> 

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/3X6qESmAaBE0pSlEssgIEt?si=7sSNkmB2RgyEfhDrz7ygsw" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-yLuM6rPvjbgplNsW-lwUwlA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>BODY IN THE TRUNK</strong><br/>
              </p>
            </a>
          </div>   

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/5EgP3p3ZD1holhBfUW1I8V?si=W7BCj8GnRs20tfMyM5HxlA" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b27382c44367bee2d4fcf3ec9ae8" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ghostsinthewalls</strong><br/>
              </p>
            </a>
          </div>                                                                                                                               
        
        </div>
      </>
    );
  };
  export default LugosiEpsStatic;